'use client';

import React from 'react';
import { cx, Color, IconVariant, Size, Sizes } from '@UI/lib/utils';
import {
  getIconColors,
  iconSizes,
  shape,
  wrapperProportions,
} from './icon.styles';

/* eslint-disable react-refresh/only-export-components */
export const IconVariants: { [key: string]: IconVariant } = {
  Simple: 'simple',
  Light: 'light',
  Shadow: 'shadow',
  Solid: 'solid',
  Outlined: 'outlined',
};

interface IconProps extends React.HTMLAttributes<HTMLSpanElement> {
  icon: React.ElementType;
  variant?: IconVariant;
  size?: Size;
  color?: Color;
}

const Icon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
  const {
    icon,
    variant = IconVariants.Simple,
    size = Sizes.SM,
    color,
    className,
    ...other
  } = props;
  const IconComponent = icon;
  const iconColorStyles = getIconColors(variant, color);

  return (
    <span
      ref={ref}
      className={cx(
        'inline-flex shrink-0 items-center justify-center',
        iconColorStyles.bgColor,
        iconColorStyles.textColor,
        iconColorStyles.borderColor,
        iconColorStyles.ringColor,
        shape[variant].rounded,
        shape[variant].border,
        shape[variant].shadow,
        shape[variant].ring,
        wrapperProportions[size].paddingX,
        wrapperProportions[size].paddingY,
        className,
      )}
      {...other}
    >
      <IconComponent
        className={cx(
          'shrink-0',
          iconSizes[size].height,
          iconSizes[size].width,
        )}
      />
    </span>
  );
});

Icon.displayName = 'Icon';

export { Icon, type IconProps };
